export default __webpack_public_path__ + "static/media/ICL.3a6e41a8.png";